<template>
  <el-form
    style="margin-top: 16px"
    :model="fieldProperties"
    ref="form"
    label-width="140px"
  >
    <template v-for="key in keys(field)">
      <el-form-item
        v-if="enabled(properties, entity, field, key)"
        :key="key"
        :label="label(field, key)"
        :rules="rules(key)"
        :prop="key"
      >
        <el-input
          v-if="htmlField(field, key) === 'text'"
          v-model="fieldProperties[key]"
        ></el-input>

        <el-select
          v-if="htmlField(field, key) === 'select'"
          v-model="fieldProperties[key]"
          placeholder="Please select one option"
        >
          <el-option
            v-if="!required(field, key)"
            label="Please select one option"
            value
          />
          <el-option
            v-for="choice in choices(field, key)"
            :key="choice.value"
            :label="choice.label"
            :value="choice.value"
          ></el-option>
        </el-select>

        <el-input-number
          v-if="htmlField(field, key) === 'number'"
          v-model="fieldProperties[key]"
        ></el-input-number>

        <el-color-picker
          v-if="htmlField(field, key) === 'color'"
          v-model="properties[key]"
        ></el-color-picker>

        <div
          class="leading-7 text-xs font-medium text-gray-500"
          v-if="help(field, key)"
        >
          {{ help(field, key) }}
        </div>
      </el-form-item>
    </template>
  </el-form>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'app-entity-form-property',

  mounted() {
    if (this.keys && this.keys(this.field)) {
      this.keys(this.field).forEach((key) => {
        const referenceKey = `tooltip${key}`;
        if (
          this.$refs[referenceKey] &&
          this.$refs[referenceKey].referenceElm
        ) {
          this.$refs[
            referenceKey
          ].referenceElm.setAttribute('tabindex', -1);
        }
      });
    }

    this.$store.commit(
      'builder/fieldCurrent/propertyForm',
      this.$refs.form,
    );
  },

  computed: {
    ...mapGetters({
      entity: 'builder/entityCurrent/current',
      properties: 'builder/propertyCurrent/current',
      entities: 'builder/entityCurrent/list',
      field: 'builder/fieldCurrent/current',
      keys: 'builder/fieldProperty/keys',
      enabled: 'builder/fieldProperty/enabled',
      required: 'builder/fieldProperty/required',
      label: 'builder/fieldProperty/label',
      htmlField: 'builder/fieldProperty/htmlField',
      help: 'builder/fieldProperty/help',
      choices: 'builder/fieldProperty/choices',
    }),

    fieldProperties() {
      return this.field.properties;
    },

    rules() {
      return (key) => {
        if (!this.required(this.field, key)) {
          return null;
        }

        const rules = {
          required: true,
          message: `${this.label(
            this.field,
            key,
          )} is required`,
          trigger: 'blur',
        };

        if (this.htmlField(this.field, key) === 'number') {
          rules.type = 'number';
        }

        return rules;
      };
    },
  },
};
</script>

<style></style>
